import { render, staticRenderFns } from "./EditSaveTemplate.vue?vue&type=template&id=5d82d9f0&scoped=true"
import script from "./EditSaveTemplate.vue?vue&type=script&lang=js"
export * from "./EditSaveTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditSaveTemplate.vue?vue&type=style&index=0&id=5d82d9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82d9f0",
  null
  
)

export default component.exports